module.exports = __webpack_public_path__ + "static/media/productlifestyleStickerBottle-large.fa813bd2.jpg";